import {z} from 'zod'
import {emptyStringToNull} from '@/validation-utils/ZodHelpers'

export const AddressSchema = z.object({
    addressLine: emptyStringToNull(z.string().trim().min(2, 'Adresselinje er for kort')),
    postalCode: z.string('sub-account.validation.address.postal-code.blank').trim().min(2, 'sub-account.validation.address.postal-code.blank'),
    postalLocation: z.string('sub-account.validation.address.postal-location.blank').trim().min(1, 'sub-account.validation.address.postal-location.blank'),
    countryCode: emptyStringToNull(z.string().trim().min(2, 'Landkode er for kort')),
})

export type Address = z.infer<typeof AddressSchema>